import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import i18n from '@/i18n'
import { AbsencesPlanView } from '@/modules/absences2'
import { semesterQueryOptions } from '@/queries/useSemesters'
import { getMetaWithPageTitle } from '@/utils/get-page-title'
import { requiredString } from '@/utils/zod'

export const Route = createFileRoute('/_auth/absences/plan')({
  validateSearch: z.object({
    semester: requiredString().catch('')
  }),
  component: () => <AbsencesPlanView />,
  loaderDeps: ({ search }) => ({ search }),
  loader: async ({ deps: { search }, context }) => {
    const semesters = await context.queryClient.ensureQueryData(
      semesterQueryOptions({})
    )
    if (!search.semester) {
      throw redirect({
        to: '/absences/plan',
        replace: true,
        search: { ...search, semester: semesters.currentSemester?.id }
      })
    }
  },
  head: () =>
    getMetaWithPageTitle([i18n.t('title.plan-absences', { ns: 'absences2' })])
})
